module.exports = __webpack_public_path__ + "img/clinking_glasses.cf68dcab.gif";